import { AnswerTemplateDataDto } from '@bondsports/types';
import { Questions } from 'types/questions';
import { ApplicationWaiver } from 'types/answer';
import { network } from 'lib/network';
import { auth } from 'lib/auth';

const apiUrl = process.env.BOND_SPORTS_API_URL;

async function getQuestionData(organizationId: number, questionnaireId: number) {
	const response = await network.get(`${apiUrl}v1/organizations/${organizationId}/questionnaire/${questionnaireId}`);

	return response.data;
}

async function getFacilityQuestionData(facilityId: number): Promise<Questions[]> {
	const response = await network.get(`${apiUrl}v1/venues/${facilityId}/questionnaire`);

	return response.data;
}

function saveApplications(data: ApplicationWaiver) {
	const { headers } = auth.getAuthHeaders();
	return network.post(`${apiUrl}v4/applications/save`, data, headers);
}

function getApplicationTemplateData(
	organizationId: number,
	userId: number,
	answerId: number,
	initialHeaders?: { accept?: string; authorization?: string | null; 'Content-Type'?: string }
): Promise<{ data: AnswerTemplateDataDto }> {
	const { headers } = auth.getAuthHeaders();

	return network.get(
		`${apiUrl}v4/applications/user/${userId}/organization/${organizationId}/answers/${answerId}/template`,
		{ headers: { ...headers, ...initialHeaders } }
	);
}

export const applicationApi = {
	getQuestionData,
	getFacilityQuestionData,
	saveApplications,
	getApplicationTemplateData,
};
